(function () {
  'use strict';

  const CLOUD_NAME   = 'duma2dq5q';
  const UPLOAD_PRESET = 'happynesso_uploads';
  const MAX_FILE_SIZE_MB = 10;
  const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  const dropzone       = document.getElementById('photo-dropzone');
  const fileInput      = document.getElementById('photo-file-input');
  const dropContent    = document.getElementById('photo-dropzone-content');
  const previewContent = document.getElementById('photo-preview-content');
  const previewImg     = document.getElementById('photo-preview-img');
  const previewName    = document.getElementById('photo-preview-name');
  const removeBtn      = document.getElementById('photo-remove-btn');
  const statusBox      = document.getElementById('photo-upload-status');
  const progressBar    = document.getElementById('photo-upload-progress-bar');
  const statusText     = document.getElementById('photo-upload-status-text');
  const errorBox       = document.getElementById('photo-upload-error');
  const successBox     = document.getElementById('photo-upload-success');
  const urlInput       = document.getElementById('photo-url-input');
  const nameInput      = document.getElementById('photo-name-input');
  const kvkkCheck      = document.getElementById('kvkk-checkbox');
  const rizaCheck      = document.getElementById('riza-checkbox');
  const addToCartBtn   = document.querySelector('[name="add"]');

  if (!dropzone || !fileInput) return;

  updateDropzoneState();
  if (kvkkCheck) kvkkCheck.addEventListener('change', updateDropzoneState);
  if (rizaCheck) rizaCheck.addEventListener('change', updateDropzoneState);

  function bothChecked() { return kvkkCheck && rizaCheck && kvkkCheck.checked && rizaCheck.checked; }

  function updateDropzoneState() {
    if (bothChecked()) { dropzone.classList.remove('dropzone-disabled'); dropzone.style.opacity = '1'; dropzone.style.pointerEvents = 'auto'; }
    else { dropzone.classList.add('dropzone-disabled'); dropzone.style.opacity = '0.45'; dropzone.style.pointerEvents = 'none'; }
    updateCartButton();
  }

  function updateCartButton() {
    if (!addToCartBtn) return;
    const ready = bothChecked() && urlInput && urlInput.value;
    addToCartBtn.disabled = !ready;
    if (ready) { addToCartBtn.removeAttribute('aria-disabled'); } else { addToCartBtn.setAttribute('aria-disabled', 'true'); }
  }

  dropzone.addEventListener('click', () => { if (bothChecked()) fileInput.click(); });
  dropzone.addEventListener('dragover', (e) => { e.preventDefault(); if (bothChecked()) dropzone.classList.add('drag-over'); });
  dropzone.addEventListener('dragleave', () => dropzone.classList.remove('drag-over'));
  dropzone.addEventListener('drop', (e) => { e.preventDefault(); dropzone.classList.remove('drag-over'); if (!bothChecked()) return; const file = e.dataTransfer.files[0]; if (file) handleFile(file); });
  fileInput.addEventListener('change', () => { const file = fileInput.files[0]; if (file) handleFile(file); });
  removeBtn.addEventListener('click', (e) => { e.stopPropagation(); resetUpload(); });

  function handleFile(file) {
    hideMessages();
    if (!ALLOWED_TYPES.includes(file.type)) { showError('Lütfen JPG, PNG veya WEBP formatında bir fotoğraf seçin.'); return; }
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) { showError('Fotoğraf boyutu maksimum 10 MB olabilir.'); return; }
    const reader = new FileReader();
    reader.onload = (e) => { previewImg.src = e.target.result; previewName.textContent = file.name; dropContent.style.display = 'none'; previewContent.style.display = 'flex'; };
    reader.readAsDataURL(file);
    uploadToCloudinary(file);
  }

  function uploadToCloudinary(file) {
    updateCartButton();
    statusBox.style.display = 'block'; setProgress(10); statusText.textContent = 'Fotoğraf yükleniyor...';
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('folder', 'happynesso/orders');
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', (e) => { if (e.lengthComputable) setProgress(Math.round((e.loaded / e.total) * 70) + 10); });
    xhr.addEventListener('load', () => {
      if (xhr.status === 200) {
        try {
          const res = JSON.parse(xhr.responseText);
          if (res.secure_url) {
            setProgress(100); statusText.textContent = 'Tamamlandı!';
            urlInput.value = res.secure_url;
            nameInput.value = file.name;
            setTimeout(() => { statusBox.style.display = 'none'; successBox.style.display = 'block'; updateCartButton(); }, 500);
          } else { handleUploadError('Yükleme başarısız oldu, tekrar deneyin.'); }
        } catch (e) { handleUploadError('Sunucu yanıtı işlenemedi.'); }
      } else { handleUploadError('Yükleme hatası (HTTP ' + xhr.status + ').'); }
    });
    xhr.addEventListener('error', () => handleUploadError('Ağ hatası. Lütfen tekrar deneyin.'));
    xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + CLOUD_NAME + '/image/upload');
    xhr.send(formData);
  }

  function setProgress(pct) { progressBar.style.width = pct + '%'; }
  function showError(msg) { errorBox.textContent = '⚠️ ' + msg; errorBox.style.display = 'block'; }
  function hideMessages() { errorBox.style.display = 'none'; successBox.style.display = 'none'; statusBox.style.display = 'none'; }
  function handleUploadError(msg) { statusBox.style.display = 'none'; showError(msg); resetUpload(); updateCartButton(); }
  function resetUpload() { fileInput.value = ''; urlInput.value = ''; nameInput.value = ''; previewImg.src = ''; previewName.textContent = ''; previewContent.style.display = 'none'; dropContent.style.display = 'flex'; hideMessages(); updateCartButton(); }

  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      if (!document.getElementById('photo-upload-section')) return;
      if (!kvkkCheck || !kvkkCheck.checked) { e.preventDefault(); e.stopImmediatePropagation(); showError('Lütfen KVKK Aydınlatma Metnini okuyup onaylayın.'); document.getElementById('photo-upload-section').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (!rizaCheck || !rizaCheck.checked) { e.preventDefault(); e.stopImmediatePropagation(); showError('Lütfen fotoğrafınızın işlenmesine açık rıza verin.'); document.getElementById('photo-upload-section').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (!urlInput.value) { e.preventDefault(); e.stopImmediatePropagation(); showError('Lütfen sepete eklemeden önce bir fotoğraf yükleyin.'); document.getElementById('photo-upload-section').scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }
})();